
































































































import _ from "lodash";
import { MaterielApi } from "../api/MaterielApi";
import Modal from "../core/Modals/Modal.vue";

export default {
    name: "EquipementPicker",
    components: { Modal },
    props: {
        showModal: Boolean,
        type: String,
        selectedIds: Array,
    },
    data() {
        return {
            MaterielApi: new MaterielApi(),
            equipements: [],
            tempSel: [],
            search: "",
            loading: false,
        };
    },
    computed: {
        title(): string {
            return this.type === "out"
                ? "↑ Sélectionner le matériel à sortir"
                : "↓ Sélectionner le matériel à rentrer";
        },
        subtitle(): string {
            return this.type === "out"
                ? "Seul le matériel disponible est affiché."
                : "Seul le matériel actuellement sorti est affiché.";
        },
        /** Équipements filtrés puis regroupés par catégorie. */
        categories(): Array<any> {
            let list = this.equipements;

            if (this.search) {
                let q = this.search.toLowerCase();
                list = _.filter(list, function (equipement) {
                    let haystack = (
                        equipement.libelle +
                        " " +
                        (equipement.modele || "") +
                        " " +
                        (equipement.emplacement_nom || "")
                    ).toLowerCase();
                    return haystack.indexOf(q) !== -1;
                });
            }

            let groupes = _.groupBy(list, function (equipement) {
                return equipement.categorie_nom || "";
            });

            return _.map(_.sortBy(_.keys(groupes)), function (nom) {
                return {
                    nom: nom,
                    equipements: _.sortBy(groupes[nom], "numero"),
                };
            });
        },
    },
    methods: {
        load(): void {
            let self = this;
            self.loading = true;
            self.MaterielApi.getEquipements({
                statut: self.type === "out" ? "disponible" : "sorti",
            })
                .then(function (res) {
                    // Le matériel hors service ne peut pas sortir ; les
                    // équipements archivés sont déjà exclus par l'API.
                    self.equipements =
                        self.type === "out"
                            ? _.filter(res, function (equipement) {
                                  return (
                                      equipement.etat_operationnel !== "broken"
                                  );
                              })
                            : res;
                    self.loading = false;
                })
                .catch(function () {
                    self.equipements = [];
                    self.loading = false;
                });
        },
        isChecked(id: number): boolean {
            return _.includes(this.tempSel, id);
        },
        toggle(id: number): void {
            if (this.isChecked(id)) {
                this.tempSel = _.without(this.tempSel, id);
            } else {
                this.tempSel = this.tempSel.concat([id]);
            }
        },
        confirm(): void {
            let self = this;
            let selection = _.filter(self.equipements, function (equipement) {
                return _.includes(self.tempSel, equipement.id);
            });
            self.$emit("confirm", selection);
        },
    },
    watch: {
        showModal: {
            immediate: true,
            handler: function (show) {
                if (show) {
                    this.search = "";
                    this.tempSel = (this.selectedIds || []).slice();
                    this.load();
                }
            },
        },
    },
};
